import AclName from '../../acl/AclName.js';
import evidenceType from '../../constants-v2/bookkeeping/evidence-type.js';
import { hasFileModuleActive } from '../../helpers/RouteHelpers.js';

export default [
  {
    path: '/evidences/kh/add',
    name: 'evidences-kh-add',
    props: {
      default: route => ({
        ...route.params,
        evidencetype: evidenceType.KH,
        hasFileModuleActive: hasFileModuleActive(route),
      }),
    },
    component: () => import('../../views/pages/evidences/components/addEdit.vue'),
    meta: {
      acl: AclName.BookkeepingPageEvidencesAdd,
      breadcrumb: [
        { title: 'Księgowość', url: { name: 'evidences-all' } },
        { title: 'Księgi handlowe', url: { name: 'evidences-all' } },
      ],
    },
  },
  {
    path: '/evidences/kh/edit/:id(\\d+)',
    name: 'evidences-kh-edit',
    props: {
      default: route => ({
        ...route.params,
        id: ~~route.params.id,
        evidencetype: evidenceType.KH,
        hasFileModuleActive: hasFileModuleActive(route),
      }),
    },
    component: () => import('../../views/pages/evidences/components/addEdit.vue'),
    meta: {
      acl: AclName.BookkeepingPageEvidencesEdit,
      breadcrumb: [
        { title: 'Księgowość', url: { name: 'evidences-all' } },
        { title: 'Księgi handlowe', url: { name: 'evidences-all' } },
      ],
    },
  },
  {
    path: '/evidences/kh-sales',
    name: 'evidences-kh-sales',
    components: {
      default: () => import('../../views/pages/evidences/kh/KhSalesList.vue'),
      topRightSection: () => import('../../views/pages/evidences/kh/components/topRightSection.vue'),
    },
    meta: {
      acl: AclName.BookkeepingPageEvidencesList,
      paginationGroupName: 'evidences-index',
      breadcrumb: [
        { title: 'Rejestr sprzedaży VAT', url: '/evidences/kh-sales' },
      ],
    },
  },
  {
    path: '/evidences/kh-purchases',
    name: 'evidences-kh-purchases',
    components: {
      default: () => import('../../views/pages/evidences/kh/KhPurchasesList.vue'),
      topRightSection: () => import('../../views/pages/evidences/kh/components/topRightSection.vue'),
    },
    meta: {
      acl: AclName.BookkeepingPageEvidencesList,
      paginationGroupName: 'evidences-index',
      breadcrumb: [
        { title: 'Rejestr zakupów VAT', url: '/evidences/kh-purchases' },
      ],
    },
  },
];
